import React from "react";
import CustomHeading from "@/components/Heading/custom-heading";
import Components from "@/components/components";
import Divider from "@/components/Divider/divider";
import styles from "./coach.module.scss";
import SbEditable from "storyblok-react";
import classnames from "classnames";
import { CoachSectionStoryblok } from "@/types/component-types-sb";

interface Props {
  blok: CoachSectionStoryblok;
}

const CoachSection = (props: Props) => {
  const {
    blok: { title, content, no_divider },
  } = props;
  const dividerClasses = classnames(
    no_divider ? styles.spacer : styles.divider
  );

  return (
    // @ts-expect-error
    <SbEditable content={props.blok}>
      <CustomHeading
        blok={{ content: title, _uid: "", component: "custom-heading" }}
        className={styles.contentHeading}
      />
      {content?.map((blok) =>
        React.createElement(Components(blok.component), {
          key: blok._uid,
          blok: blok,
          className: styles.contentItem,
          style: { "--col-start": "col-4", "--col-end": "main-end" },
        })
      )}
      <Divider className={dividerClasses} />
    </SbEditable>
  );
};

export default CoachSection;
